import { useMutation, useQuery } from "@apollo/client/react";

import { Ingredient } from '../../models/ingredient'
import { Buy } from '../../models/buy'

export const useShopData = () => {
  const { data, loading } = useQuery(Buy.fetch, {
    fetchPolicy: 'cache-and-network',
    pollInterval: 10000
  })
  const buys = data && data.buys || []

  Buy.useBuyUpdate()
  Buy.useBuyBuyUpdate()
  const [ ingredientUpdate ] = useMutation(Ingredient.update)
  const [ buyAdd ] = useMutation(Buy.methods.add)
  const [ buyBuy ] = useMutation(Buy.methods.buy)
  const [ buyPostpone ] = useMutation(Buy.methods.buyPostpone, {
    refetchQueries: () => [ 'BuysList' ]
  })

  const now = new Date()
  const buysWithPostpone = buys
    .map(buy => {
      const until = new Date(buy.postponedUntil)

      return {
        ...buy,
        postponed: buy.postponedUntil && now <= until
      }
    })
    // Orden estable: da igual quién escriba la caché (optimista,
    // subscripción o polling), el orden renderizado no cambia
    .sort((a, b) => {
      const nameA = a.ingredient && a.ingredient.name || ''
      const nameB = b.ingredient && b.ingredient.name || ''

      return nameA.localeCompare(nameB)
    })

  return {
    buys: buysWithPostpone.filter(buy => !buy.postponed),
    postponedBuys: buysWithPostpone.filter(buy => buy.postponed),
    loading,
    doAdd: variables =>
      buyAdd({
        variables: {
          input: variables
        }
      }),
    doBuy: (buy, placeId) => {
      const { postponed, ...buyFields } = buy

      return buyBuy({
        variables: { id: buy.id, placeId: placeId || null },
        update: (proxy, { data: buyData }) => {
          const buyBuy = buyData && buyData.buyBuy
          if (buyBuy) {
            const id = proxy.identify(buyBuy)
            proxy.evict({ id })
          }
        },
        optimisticResponse: {
          __typename: 'Mutation',
          buyBuy: buyFields
        }
      })
    },
    postpone: (id, seconds) =>
      buyPostpone({
        variables: { id, seconds }
      }),
    ingredientUpdate: doc =>
      ingredientUpdate(Buy.formConvert(doc))
  }
}
